import { Fatigue } from "@/components/report/Fatigue";
import {
  FatigueResponse,
  ReportPageBaseProps,
} from "@/components/report/types";
import { useAxios } from "@/utils/axios";
import { usePageUserType } from "@/utils/router";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export function FatiguePage({ setIndicator }: ReportPageBaseProps) {
  const { uuid } = useParams();
  const userType = usePageUserType();
  const axios = useAxios();
  const [data, setData] = useState<FatigueResponse | null>(null);
  useEffect(() => {
    (async () => {
      const response = await axios.get(`/api/report/${uuid}/fatigue`);
      setData(response.data);
      setIndicator(false);
    })();
  }, [axios, uuid, setIndicator]);

  if (uuid == null || data == null) return <></>;

  return <Fatigue data={data} userType={userType} uuid={uuid} />;
}
